'use client';
import React, { ChangeEvent, FC, useEffect, useRef, useState } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input: FC<InputProps> = ({ value: parentValue, onChange, ...props }) => {
  const [value, setValue] = useState<any>('');
  const isControlled = useRef<boolean>(false);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    onChange?.(event);
  };

  useEffect(() => {
    if (parentValue) {
      isControlled.current = true;
    }
  }, [parentValue]);

  useEffect(() => {
    if (isControlled) {
      setValue(parentValue);
    }
  }, [parentValue, isControlled]);

  return <input {...props} value={value} onChange={handleChange} />;
};

export default Input;
